<mat-toolbar class="toolbar-style"
             *ngIf="!noHeader">
  <button mat-icon-button *ngIf="isSmallScreen || isAdminPage" (click)="openSidenav()" class="design-button">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="toolbar-logo-div clickable"
       (click)="onLogoClicked()">
    <img *ngIf="!isSmallScreen" src="assets/icons/icon-flex-72x72.png" alt="logo-pc" class="toolbar-logo">
    <img *ngIf="isSmallScreen" src="assets/svg/dmsone-logo.svg" alt="logo-mobile" class="toolbar-logo">
  </div>
  <span class="example-spacer" *ngIf="isSmallScreen"></span>
<!--  <button mat-stroked-button [routerLink]="'/dashboard'" *ngIf="isBackToList&&isSmallScreen">-->
<!--    <mat-icon>keyboard_arrow_left</mat-icon>-->
<!--    {{'BACK' | translate}}-->
<!--  </button>-->

  <mat-tab-group *ngIf="!isSmallScreen && !isAdminPage"
                 (selectedIndexChange)="onTabChange($event)"
                 [selectedIndex]="selectedTabIndex" class="hide-first-tab">
    <mat-tab></mat-tab>
    <mat-tab label="{{'MY_TASKS' | translate}}"></mat-tab>
    <mat-tab label="{{'MY_DOCUMENTS' | translate}}"></mat-tab>
  </mat-tab-group>

  <span *ngIf="!isSmallScreen" class="example-spacer"></span>
  
  <!-- User Menu Button -->
  <button mat-button [matMenuTriggerFor]="userMenu" *ngIf="!isSmallScreen" class="user-email vertical-positioning">
    {{userEmailService.emailAddress}}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  
  <button mat-icon-button [matMenuTriggerFor]="lang" *ngIf="!isSmallScreen" class="design-button vertical-positioning">
    <mat-icon>translate</mat-icon>
  </button>
  <!--      <button mat-icon-button *ngIf="isSmallScreen || isAdminPage" (click)="openSidenav()" class="design-button">-->
  <!--        <mat-icon>menu</mat-icon>-->
  <!--      </button>-->
  <button mat-button class="design-button vertical-positioning"
          *ngIf="!isSmallScreen"
          (click)="logOut()">
    {{'LOGOUT' | translate}}
    <mat-icon>exit_to_app</mat-icon>
  </button>

</mat-toolbar>
<mat-sidenav-container class="container" hasBackdrop="true" (backdropClick)="sidenavToggle.isShowing=false">

  <mat-sidenav fixedInViewport="true"
               class="sidenav"
               mode="over"
               [opened]="sidenavToggle.isShowing" autoFocus="false">
      <mat-toolbar class="toolbar-background toolbar-width">
  <!--      <img src="assets/person.png" class="avatar" alt="person" height="32">-->
        <button mat-icon-button disabled="true">
          <mat-icon>account_circle</mat-icon>
        </button>
        <p class="small-font-size">
          {{userEmailService.emailAddress}}
        </p>
        <span class="example-spacer"></span>
        <button mat-icon-button class="design-button" (click)="sidenavToggle.isShowing=false">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>
      <mat-nav-list class="sidenav-list">
        <mat-list-item *ngFor="let link of isAdmin()"
                       [routerLink]="[link.routeLink]"
                       routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}"
                       (click)="sidenavToggle.isShowing=false">
          <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
          <span>{{ link.label | translate}}</span>
        </mat-list-item>
      </mat-nav-list>
    <div class="sidenav-footer">
      <mat-nav-list>
  <!--      <button mat-button [matMenuTriggerFor]="lang" class="design-button footer-button">-->
  <!--        {{getLanguage()}}-->
  <!--        <mat-icon>arrow_drop_up</mat-icon>-->
  <!--      </button>-->
        <mat-list-item class="design-button"
                (click)="logOut()">
          <mat-icon matListItemIcon>exit_to_app</mat-icon>
          <span>{{'LOGOUT' | translate}}</span>
        </mat-list-item>
      </mat-nav-list>
      <button mat-icon-button [matMenuTriggerFor]="lang" class="design-button">
        <mat-icon>translate</mat-icon>
      </button>
    </div>
<!--    <button mat-button (click)="logOut();sidenavToggle.isShowing=false" style="position: absolute;bottom: 10px;right: 20px;">{{'LOGOUT' | translate}}</button>-->
  </mat-sidenav>

  <mat-sidenav-content style="height: 100%">

    <div *ngIf="spinnerVisibility" class="spinner"><mat-spinner></mat-spinner></div>

    <app-body style="flex: 1; overflow-y: auto"></app-body>

  </mat-sidenav-content>
</mat-sidenav-container>
<!-- User Menu -->
<mat-menu #userMenu="matMenu" xPosition="before">
  <button mat-menu-item routerLink="/settings/tokens">
    <mat-icon>vpn_key</mat-icon>
    <span>{{'PERSONAL_ACCESS_TOKENS' | translate}}</span>
  </button>
  <button mat-menu-item routerLink="/admin/station-list" *ngIf="isAdminUser">
    <mat-icon>admin_panel_settings</mat-icon>
    <span>{{ 'STATION_MANAGEMENT' | translate }}</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logOut()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{'LOGOUT' | translate}}</span>
  </button>
</mat-menu>

<!-- Language Menu -->
<mat-menu #lang="matMenu" xPosition="before">
  <button mat-menu-item *ngFor="let language of languages"
          [disabled]="selectedLang === language.code"
          (click)="changeLanguage(language.code)">
    {{ language.name }} ({{language.code}})
  </button>
</mat-menu>



